const ShowIcon = ({
  color = "var(--grey400)",
  size = 24,
  onClick = () => {},
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M22.8819 11.4483C22.1763 10.2245 18.2955 4.0836 11.7024 4.28205C5.60557 4.4364 2.07753 9.79454 1.11835 11.4483C1.02159 11.6159 0.970642 11.806 0.970642 11.9995C0.970642 12.1931 1.02159 12.3832 1.11835 12.5508C1.81293 13.7525 5.52839 19.717 12.0222 19.717H12.2978C18.3947 19.5627 21.9337 14.2045 22.8819 12.5508C22.9787 12.3832 23.0296 12.1931 23.0296 11.9995C23.0296 11.806 22.9787 11.6159 22.8819 11.4483ZM12.2427 17.512C7.49086 17.6223 4.39281 13.5541 3.4226 11.9995C4.52511 10.2245 7.40266 6.5973 11.8127 6.48705C16.5425 6.36577 19.6516 10.445 20.6328 11.9995C19.4972 13.7746 16.6527 17.4018 12.2427 17.512Z"
        fill={color}
      />
      <path
        d="M12.0001 8.14079C11.2369 8.14079 10.4909 8.36711 9.8563 8.79111C9.22173 9.21512 8.72714 9.81777 8.43507 10.5229C8.14301 11.228 8.06659 12.0038 8.21549 12.7523C8.36438 13.5009 8.73189 14.1884 9.27155 14.7281C9.81121 15.2677 10.4988 15.6353 11.2473 15.7841C11.9958 15.933 12.7717 15.8566 13.4768 15.5646C14.1819 15.2725 14.7846 14.7779 15.2086 14.1433C15.6326 13.5088 15.8589 12.7627 15.8589 11.9995C15.8589 10.9761 15.4524 9.99465 14.7287 9.271C14.005 8.54734 13.0235 8.14079 12.0001 8.14079ZM12.0001 13.6533C11.673 13.6533 11.3533 13.5563 11.0813 13.3746C10.8094 13.1929 10.5974 12.9346 10.4722 12.6324C10.3471 12.3302 10.3143 11.9977 10.3781 11.6769C10.4419 11.3561 10.5995 11.0614 10.8307 10.8302C11.062 10.5989 11.3567 10.4414 11.6775 10.3776C11.9983 10.3138 12.3308 10.3465 12.633 10.4717C12.9352 10.5968 13.1935 10.8088 13.3752 11.0808C13.5569 11.3527 13.6539 11.6725 13.6539 11.9995C13.6539 12.4381 13.4797 12.8588 13.1695 13.1689C12.8594 13.4791 12.4387 13.6533 12.0001 13.6533Z"
        fill={color}
      />
    </svg>
  );
};

export default ShowIcon;
